const initCarousel = () => {
    const arrayCarousel = document.querySelectorAll("[data-carousel]");
    if (arrayCarousel && arrayCarousel.length > 0) {
        arrayCarousel.forEach((carouselContainer) => {
            const arraySliderItems = carouselContainer.querySelectorAll("[data-slide]");
            //Max number of items that could exist into the father container
            const maxNumberOfItems = ((carouselContainer.clientWidth + (arraySliderItems[0].offsetWidth - arraySliderItems[0].clientWidth)) / arraySliderItems[0].offsetWidth);
            //Array of slider item (How many slide there are on the carousel)
            const actualSliderItemsNumber = arraySliderItems.length;
            //If Number max is less than item exist then initialize slider carousel or add a calss to center item
            if (actualSliderItemsNumber > maxNumberOfItems) {
                new Flickity(carouselContainer, {
                    //slider options
                    cellAlign: 'left',
                    contain: true,
                    wrapAround: true,
                    autoPlay: false
                });
            }
            else {
                carouselContainer.classList.add("is-not-slider");
            }
        });
    }
};
